export default __webpack_public_path__ + "static/media/neural.55f29f3f.png";